import React from 'react'
import { withRouter } from 'react-router-dom'
import {
	FormControl,
	TextField,
	Typography,
	FormControlLabel,
	Switch
} from '@material-ui/core'
import { post_query } from './../../functions'
import { Mcedit } from '../../containers/modules/Mcedit'


// new trouble
class TroublesNew extends React.Component {
	constructor(props){
		super(props)
		this.state = {
			loader: false,
			label: '',
			viewrecord: false,
			description: ''
		}
	}

	saveData(description){
		this.setState({ loader: true })
		let data = {
			label: this.state.label,
			viewrecord: this.state.viewrecord,
			content: description
		}
		post_query('/api/troubles/add', data)
		.then((res) => {
			this.props.history.push(`/troubles`)
		})
		.catch((err) => {
			this.setState({ loader: false })
		})
	}

	goBack(){
		this.props.history.push('/troubles')
	}

	render(){
		return(
			<>
				<Typography variant='h4'>
					Новая проблема в модуль сайта
				</Typography>
				<div>
					<div>
						<FormControl
							className='form-item'
						>
							<TextField 
								inputProps={{style:{ width: 700 }}}
								label='Тема проблемы'
								value={this.state.label}
								onChange={(ev) => this.setState({ label: ev.target.value })}
							/>
						</FormControl>
					</div>
					<div>
						<FormControlLabel
							value='start'
							control={
								<Switch 
									color="primary" 
									checked={this.state.viewrecord}
									onChange={(ev) => this.setState({ viewrecord: ev.target.checked })}
								/>
							}
							label={this.state.viewrecord ? 
								<p style={{width: 120}}>Показано</p> : 
								<p style={{width: 120}}>Скрыто</p>
							}
							labelPlacement="start"
						/>
					</div>
				</div>
				<Mcedit
					loader={this.state.loader}
					initialValue={this.state.description}
					goBack={() => this.goBack()}
					saveAction={(c) => this.saveData(c)}
				/>
			</>
		)
	}
}

export default withRouter(TroublesNew)


